import gql from "graphql-tag";

export const MY_TIMESHEET_GET_GROUPED_BY_USERS_DASHBOARD_WEEKLY_LIST = gql`
  mutation groupedByUsersDashboardWeeklyList(
    $page: Int!
    $pageSize: Int!
    $startTime: Date!
    $endTime: Date!
    $roleFilters: RoleFilterInput
    $sortField: String
    $sortDirection: String
    $searchField: String
    $searchText: String
    $role: String
  ) {
    groupedByUsersDashboardWeeklyList(
      page: $page
      pageSize: $pageSize
      startTime: $startTime
      endTime: $endTime
      roleFilters: $roleFilters
      sortField: $sortField
      sortDirection: $sortDirection
      searchField: $searchField
      searchText: $searchText
      role: $role
    ) {
      page
      pageSize
      total
      totalPages
      rows {
        employeeCode
        employeeName
        contractId
        days {
          day
          duration
        }
      }
    }
  }
`;
